import React from 'react';
import { Outlet } from 'react-router-dom';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      {children || <Outlet />}
    </div>
  );
};

export default Layout;
